<template>
    <b-card class="block__objectiveListBonus">
      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>          
            {{title}}
          </PuSkeleton>
        </p>
        <p class="number">
          <PuSkeleton :loading="isLoading" width="20px">          
            {{objectifNumber}}
          </PuSkeleton>
        </p>
      </header>

      <!-- <div class="sep"></div> -->

      <b-list-group>
        <b-list-group-item v-for="(list,index) of lists" :key="index">
          <div class="entete">
            <div class="left">
                <PuSkeleton :loading="isLoading" :count="1" width='160px'>          
                  <div v-if="list.title" class="title">{{list.title}}</div>
                  <div v-if="list.etiquette && list.etiquette === 'progress'" class="target green">En cours</div>
                  <div v-if="list.etiquette && list.etiquette === 'done'" class="target done">Terminer</div>
                </PuSkeleton>
            </div>
            <div v-if="list.number" class="number">
              <PuSkeleton :loading="isLoading" width="20px">
                {{list.number}}
              </PuSkeleton>
            </div>
          </div>
          <div v-if="list.label" class="label">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>            
              {{list.label}}
            </PuSkeleton>
          </div>
          <div v-if="list.subLabel" class="subLabel">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>            
              {{list.subLabel}}
            </PuSkeleton>
          </div>
        </b-list-group-item>
      </b-list-group>


    </b-card>
</template>


<script>

export default {
name:"wrapperObjectiveListBonus",
  props:{
    title:{
      type:String,
      default:'Bonus excursion'
      },
    objectifNumber:{
      type:Number,
      default:0
      },
    lists:{
      type:Array,
      },
  },
  data(){
    return {
      isLoading:true,
    }
  },
  mounted () {
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  } 
}
</script>